/* eslint-disable new-cap */
/* eslint-disable camelcase */
import ABCyaPhaser, { Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import AudioPlayer from '../library/AudioPlayer';
import DepressableButton from '../library/DepressableButton';
import BasicSprite from '../objects/BasicSprite';
import DoorScene from './DoorScene';
import LevelSelect from './LevelSelect';
import MainMenu from './MainMenu';
import gameData from '../gameData';

export default class MenuPopup extends Phaser.Scene {
  static get KEY() {return 'MenuPopup';}

  create(sceneFrom) {
    this.sceneFrom = sceneFrom.sceneFrom;

    this.scene.bringToTop(MenuPopup.KEY);
    this.scene.pause(this.sceneFrom);
    this.onDisplay = null;
    this.onHide = null;

    this.overlay = new BasicSprite(this, 0, 0, 'pauseOverlay', 0);
    this.overlay.setOrigin(0);
    this.add.existing(this.overlay);

    this.menuButton = new DepressableButton(this, this.scale.width * .5, this.scale.height * .5 - 75, 'menuButton2', 'menuButton2_Depressed', () => {this.eh_MenuButton_Clicked();}, ABCyaPhaser.Localization.instance.getLocalizedString('menu_button'));
    this.resumeButton = new DepressableButton(this, this.scale.width * .5, this.scale.height * .5 + 75, 'menuButton2', 'menuButton2_Depressed', () => {this.eh_ResumeButton_Clicked();}, ABCyaPhaser.Localization.instance.getLocalizedString('resume_button'), { maxWidth: 310, maxHeight: 70 });

    this.menuButton.button.setScale(0);
    this.resumeButton.button.setScale(0);

    this.overlay.alpha = 0;

    this.Display();
  }

  toggleInput(toggle) {
    if (toggle) {
      this.menuButton.button.setInteractive();
      this.resumeButton.button.setInteractive();
      this.overlay.setInteractive();
    }
    else {
      this.menuButton.button.disableInteractive();
      this.resumeButton.button.disableInteractive();
      this.overlay.disableInteractive();
    }
  }

  removeTweens() {
    this.tweens.killTweensOf(this.menuButton.button);
    this.tweens.killTweensOf(this.resumeButton.button);
    this.tweens.killTweensOf(this.overlay);
  }

  eh_ResumeButton_Clicked() {
    AudioPlayer.PlaySound(this, AudioPlayer.sounds.CLICK);
    this.Hide(true);
  }

  eh_MenuButton_Clicked() {
    this.Hide();

    AudioPlayer.PlaySound(this, AudioPlayer.sounds.CLICK);

    this.onDisplay = null;
    this.onHide = null;

    let level = LevelSelect.KEY;
    if (!gameData.config.showOptions) {
      gameData.indexStart = 0;
      gameData.curLevel = 1;
      level = MainMenu.KEY;
    }

    this.scene.get(DoorScene.KEY).changeScene(this.sceneFrom, level);
  }

  Display() {
    if (this.onDisplay !== null) this.onDisplay();

    this.removeTweens();
    this.toggleInput(true);

    Tweens.addTween(this.overlay, 500, { alpha: 1 }, Phaser.Math.Easing.Quadratic);
    Tweens.addTween([this.menuButton.button, this.resumeButton.button], 500, { scale: 1 }, Phaser.Math.Easing.Back.Out);
  }

  Hide(resume) {
    if (this.onHide !== null) this.onHide();

    this.removeTweens();
    this.toggleInput(false);

    Tweens.addTween(this.overlay, 200, { alpha: 0 }, Phaser.Math.Easing.Quadratic);
    Tweens.addTween([this.menuButton.button, this.resumeButton.button], 200, { scale: 0 }, Phaser.Math.Easing.Quadratic, () => {
      if (resume) {
        this.scene.resume(this.sceneFrom);
      }
      this.scene.stop();
    });
  }
}